import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Note } from './prescription-note-model';
import { environment } from 'src/environments/environment';
import { currentUser } from 'src/app/core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionNoteService {
  private baseUrl: string = environment.CORE_BASE;
  //  private baseUrl: string = 'http://localhost:8080'
  private companyId: any;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store
      .pipe(
        select(currentUser),
        filter((res) => !!res && !!res.companyID),
      )
      .subscribe((res) => {
        this.companyId = res.companyID;
        this.baseUrl = `${this.baseUrl}/companies/${this.companyId}/patients/prescription`;
      });
  }

  getNotes(prescriptionId: number): Observable<any> {
    const apiUrl = `${this.baseUrl}/${prescriptionId}/notes`;
    return this.companyId ? this.http.get(apiUrl) : new Observable();
  }

  updateNote(noteId: number, requestBody: Partial<Note>): Observable<any> {
    const apiUrl = `${this.baseUrl}/notes/${noteId}`;
    return this.http.put(apiUrl, requestBody);
  }

  deleteNote(noteId: number): Observable<any> {
    const apiUrl = `${this.baseUrl}/notes/${noteId}`;
    return this.http.delete(apiUrl);
  }

  createNote(prescriptionId: number, requestBody: Partial<Note>): Observable<any> {
    const apiUrl = `${this.baseUrl}/${prescriptionId}/notes`;
    return this.http.post(apiUrl, requestBody);
  }
}
